//region :: Imports ::
import {ICustomProperties} from '@microsoft/applicationinsights-web';
import ILogger from './ILogger';
import ConsoleLogger from './ConsoleLogger';
import AppInsightsLogger from './AppInsightsLogger';
import Environment from '../../Environment';

//endregion

/** */
class Logger {

    /** */
    private static getLogger(): ILogger {
        return Environment.isLocal || Environment.isDevelopment ? new ConsoleLogger() : new AppInsightsLogger();
    }

    /** */
    public static trackInfo(message: string, properties?: ICustomProperties): void {
        Logger.getLogger().trackInfo(message, properties);
    }

    /** */
    public static trackWarning(message: string, properties?: ICustomProperties): void {
        Logger.getLogger().trackWarning(message, properties);
    }

    /** */
    public static trackError(error: Error, properties?: ICustomProperties): void {
        Logger.getLogger().trackError(error, properties);
    }

}

export default Logger;
